import http from "../../../services/httpService";
import { error, isEmpty } from "../../common/global";
import { catchError } from "../../../utils/errorUtil";
import { openDialog, dialogModel } from "../../common/dialog";

const props = {
    adminContentItemEditMarker:'.marker-contact-us-content-item-edit',
    deleteContentItemButton: '#delete-content-item',
    textContentSelector: '#TextContent',
    backLink: '#back-link'
};

export function initAdminContactUsEditContentItem() {
    if ($(props.adminContentItemEditMarker).length) {
        bindDeleteContentItem();

        tinymce.init({
            selector: props.textContentSelector,
            plugins:
                'advlist anchor autolink charmap code  fullscreen   lists paste searchreplace  help', //table image codesample link
            toolbar:
                'bold italic underline forecolor | ' +
                'bullist numlist | fullscreen | ' +
                ' charmap | ' + //table link codesample
                'alignleft aligncenter alignright alignjustify ' +
                'help',
            menu: {
                file: {
                    title: 'File',
                    items: ''
                },
                edit: {
                    title: 'Edit',
                    items: 'undo redo | cut copy paste pastetext | selectall | searchreplace'
                },
                view: {
                    title: 'View',
                    items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments'
                },
                //insert: {
                //    title: 'Insert',
                //    items: 'image link media addcomment pageembed template codesample inserttable | charmap hr | pagebreak nonbreaking anchor toc | insertdatetime'
                //},
                format: {
                    title: 'Format',
                    items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats align | forecolor | removeformat'
                },
                tools: {
                    title: 'Tools',
                    items: ''
                },
                //table: {
                //    title: 'Table',
                //    items: 'inserttable | cell row column | advtablesort | tableprops deletetable'
                //},
                help: {
                    title: 'Help',
                    items: 'help'
                }
            },
            force_p_newlines: false,
            forced_root_block: '',
            //For more styles use content_css (see the docs)
            content_style: "body { font-size: 14px; }",
            height: 480
        });
    }
}


function bindDeleteContentItem(){
    $(props.deleteContentItemButton).click(function () {

        const contentItemId = $(this).data('id');

        openDialog({
            ...dialogModel,
            title: 'Delete Contact Us Content Item',
            content: 'Are you sure you want to delete this Contact Us Content Item?',
            confirmButtonText: 'Delete',
            onConfirm: () => deleteContentItem(contentItemId),
            theme: 'delete'
        });
    });
}

async function deleteContentItem(contentItemId) {

    catchError(async function () {
        //attempt POST save, then check response

        const data = { id: contentItemId };

        const response = await deleteContentItemService(data);

        if (response.responseType === "SUCCESS") {

            //success; redirect to the page that the user visited to get to this page
            var redirectUrl = $(props.backLink).attr("href");

            window.location.replace(redirectUrl);
        }
        else {

            //request failed; display popup for responsemessage to alert the user as to why
            openDialog({
                ...dialogModel,
                title: 'Error Encountered During Request',
                content: response.responseMessage,
                displayConfirm: false,
                cancelButtonText: 'Close',
                theme: 'delete'
            });
        }
    });
}

//API CALLS
async function deleteContentItemService(data) {

    //no TRY CATCH as handled by parent
    const response = await http.post('/administration/contactusmanagement/deletecontentitem', data);

    return response.data;
}